export interface AuthRedirectRouteLike {
  path?: string | null;
  fullPath?: string | null;
}

export interface AuthRouteRedirectOptions {
  loggedIn: boolean;
  path?: string | null;
  redirect?: unknown;
  defaultPath: string;
}

export function buildRedirectQueryValue(routeLike: AuthRedirectRouteLike) {
  return routeLike.fullPath || routeLike.path || '/';
}

export function buildLoginRedirectUrl(redirectTarget: string, baseUrl: string, loginPath = '/auth/login') {
  const safeRedirectTarget = resolveSafeRedirectTarget(redirectTarget);

  if (!safeRedirectTarget) {
    return new URL(loginPath, baseUrl).toString();
  }

  const url = new URL(loginPath, baseUrl);
  url.searchParams.set('redirect', safeRedirectTarget);
  return url.toString();
}

export function resolveAuthRouteRedirect({ loggedIn, path, redirect, defaultPath }: AuthRouteRedirectOptions) {
  if (!loggedIn) return null;

  const currentPath = path?.trim() || '';
  const isLoginRoute = /(^|\/)auth\/login$/.test(currentPath);

  if (!isLoginRoute) return null;

  return resolveSafeRedirectTarget(redirect) || defaultPath;
}

export function resolveSafeRedirectTarget(redirect: unknown) {
  if (typeof redirect !== 'string') return null;

  const value = redirect.trim();

  if (!value.startsWith('/') || value.startsWith('//')) {
    return null;
  }

  return value;
}

export function resolveAuthenticatedLoginRedirect(loggedIn: boolean, redirect: unknown) {
  if (!loggedIn) return null;
  return resolveSafeRedirectTarget(redirect);
}
